import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchTaxrate, editTaxrate, deleteTaxrate, clearTaxrateErrors } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import EditItem from '../components/taxrate/EditTaxrate';
import Alert from '../components/home/Alert';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  taxrates: PropTypes.object,
  params: PropTypes.object,
  error: PropTypes.any,
};

class TaxrateEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewRedirect: false,
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchTaxrate(this.props.params.zipcode));
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        edited: false,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
        error: true,
      });
    }
    if (nextProps.taxrates.taxrate && !nextProps.error && this.state.edited) {
      this.setState({
        alertOpen: true,
        alertMessage: 'Tax rate edited succesfully!',
        error: false,
      });
    }
  }
  deleteTaxRate(taxRateId) {
    const taxrates = this.props.taxrates;
    taxrates.delete = true;
    this.setState({ taxrates });
    this.props.dispatch(deleteTaxrate(taxRateId));
    browserHistory.push('/taxrate?page=1');
  }
  saveEditTaxrate(taxrate) {
    this.setState({
      edited: true,
    });
    this.props.dispatch(editTaxrate(taxrate));
  }
  navigateToView(taxrate) {
    const nextState = this.state;
    nextState.viewRedirect = true;
    nextState.edited = true;
    this.setState(nextState);
    this.props.dispatch(editTaxrate(taxrate));
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
    });
    this.props.dispatch(clearTaxrateErrors());
    if (!this.state.error) {
      if (this.state.viewRedirect === true) {
        this.setState({ viewRedirect: false });
        browserHistory.push(`/taxrate/view/${this.props.params.zipcode}`);
      } else {
        browserHistory.push('/taxrate?page=1');
      }
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="taxrate component" style={authPage}>
        <h2>Edit Tax Rate</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <EditItem
            taxrate={this.props.taxrates.taxrate}
            onSave={data => this.saveEditTaxrate(data)}
            onDelete={data => this.deleteTaxRate(data)}
            onView={data => this.navigateToView(data)}
          />
        </div>
      </div>
    );
  }
}

TaxrateEditPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

TaxrateEditPage.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    taxrates: state.taxrates,
    error: state.taxrates.error,
  };
}

export default withRouter(connect(mapStateToProps)(TaxrateEditPage));



// WEBPACK FOOTER //
// ./src/containers/TaxrateEditPage.js